<template lang="pug">
  div
    //- This is the actual popover component, displayed on larger screens
    //- than mobile.
    v-popover.cursor-pointer(
      :placement="placement"
      :popover-base-class="popoverBaseClasses"
      :trigger="trigger"
      class="hidden md:grid"
    )
      slot
      div(slot="popover")
        slot(name="popover-content")

    //- On mobile, we display our modal component instead of the popover for
    //- better UX. We thus pass the pop-over slot content received from the
    //- view to the modal-content slot so it can render it on its behalf.
    sw-modal(class="md:hidden")
      slot
      div(slot="modal-content")
        slot(name="popover-content")

</template>

<script>
import { VPopover } from 'v-tooltip';
import { removeSwVCloak } from '../../mixins/removeSwVCloak';

export default {
  name: 'SwPopover',
  components: {
    VPopover,
  },
  mixins: [removeSwVCloak],
  props: {
    customClasses: {
      type: String,
      default: '',
    },
    placement: {
      type: String,
      default: 'top',
      validator: value => ['top', 'bottom', 'left', 'right'].includes(value),
    },
    trigger: {
      type: String,
      default: 'click',
    },
  },
  computed: {
    popoverBaseClasses () {
      return `popover ${this.customClasses}`;
    },
  },
};
</script>

<style lang="scss">
  .popover {
    .tooltip-arrow {
      @apply text-current border-8 absolute border-transparent block;
    }
    &[x-placement="left"] .tooltip-arrow {
      @apply border-l-current border-r-0 border-l-12 -right-4 top-1/2 -ml-4;
    }
    &[x-placement="right"] .tooltip-arrow {
      @apply border-r-current border-l-0 border-r-12 top-1/2 -ml-4;
    }
    &[x-placement="bottom"] .tooltip-arrow {
      @apply border-b-current border-t-0 border-b-12 -top-4 left-1/2 -mb-4;
    }
    &[x-placement="top"] .tooltip-arrow {
      @apply border-t-current border-b-0 border-t-12 bottom-0 left-1/2 -mb-4;
    }
  }
</style>
